import { BaseController } from '~client/controller/base-controller';
import { EventDetailResponse } from '~client/model/event-detail-response';
import { EventFilter } from '~client/model/event-filter';
import { EventListResponse } from '~client/model/event-list-response';
import { EventTagInfoResponse } from '~client/model/event-tag-info-response';

/* User APIs pertaining to Events */
export class EventController extends BaseController {
  /* Returns a specific event. */
  public getEventProfile(eventId: string): Promise<EventDetailResponse> {
    return this.get('/event/public/profile', { eventId });
  }

  /* Returns all upcoming events */
  public getUpcomingEvents(): Promise<EventListResponse> {
    return this.get('/event/public/profileList', {
      showOnlyNonLiveStreamEvents: false,
      showUpcomingEvents: true,
    });
  }

  /*
   * Returns tag information along with events related to that tag. The first tag passed in should
   * be the primary tag.
   */
  public getUpcomingEventsWithTags(eventFilter: EventFilter): Promise<EventTagInfoResponse> {
    return this.put('/event/public/profileList/tag', eventFilter);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/event-controller.ts